<template>
  <div class="about-wrap bg--about">
      <div class="about-container clear">
          <h2 class="center caps">About</h2>
          <h1 class="spacer--small">A guide to typography with character.</h1>
          <h3 class="serif weight--400">Hi there!</h3>
          <h3 class="serif weight--400">It all began when I realized I could combine my love for cultural comparisons and graphic design. This has taken many forms during my studies and has stayed with me since.</h3>
          <h3 class="serif weight--400">By comparing English and Korean, Types of Type shows that there are many similarities across the two languages through the lens of typography. And, the differences between the two are equally telling. I learned a lot from putting this guide together, and hope you enjoy it.</h3>
          <h3 class="serif weight--400">Amanda</h3>
          <!-- <p class="serif about-link weight--400">Let's talk!<br /><a href="mailto:hello@amandalui.com">hello@amandalui.com</a></p> -->
          <div class="spacer--small"></div>
          <div class="column--half spacer--small">
              <p>
                <span class="bold">
                    Writing and Design
                </span><br />
                    <span class="serif">
                    <div class="headshot"><img src="/static/images/about/amanda-lui.png" alt="Amanda"><br /></div>
                    <div class="about-link"><a href="http://amandalui.com" target="_blank">Amanda Lui</a></div>
                    <span class="caption">Designer</span><br />
                    <div class="social-media">
                        <a href="https://github.com/amandalui" target="_blank"><img src="/static/images/about/icon-git.svg" alt="Github"></a>
                    </div><br />
                  </span>
              </p><br />
              <p>
                <span class="bold">
                      Website in collaboration with
                </span><br />
                <div class="serif column--half">
                    <div class="headshot"><img src="/static/images/about/jeremiah-montoya.png" alt="Jeremiah"><br /></div>
                    <div class="about-link"><a href="https://github.com/thisjeremiah" target="_blank">Jeremiah Montoya</a></div>
                      <span class="caption">Developer</span><br />
                    <div class="social-media">
                        <!-- <a href="https://twitter.com/thisjeremiah" target="_blank"><img src="/static/images/about/icon-twitter.svg" alt="Twitter"></a> -->
                        <a href="https://github.com/thisjeremiah" target="_blank"><img src="/static/images/about/icon-git.svg" alt="Github"></a>
                    </div><br />
                </div>
                <div class="serif column--half">
                     <div class="headshot"><img src="/static/images/about/nathan-specht.png" alt="Nathan"><br /></div>
                     <div class="about-link"><a href="https://github.com/nathanspecht" target="_blank">Nathan Specht</a></div>
                     <span class="caption">Developer</span><br />
                    <div class="social-media">
                        <a href="https://github.com/nathanspecht" target="_blank"><img src="/static/images/about/icon-git.svg" alt="Github"></a>
                    </div><br />
                </div>
              </p>
              <div class="clear spacer--tiny"></div>
              <p class="about-link"><span class="bold">Special Thanks</span><br />
                  <span class="serif"><a href="http://romanjaster.com/" target="_blank">Roman Jaster</a></span><br />
                  <span class="serif"><a href="http://soonsol.com/" target="_blank">Soonsol Hong</a></span><br />
                  <span class="serif"><a href="https://elizabethjayna.com/" target="_blank">Elizabeth Lui</a></span><br />
                  <span class="serif"><a href="http://cargocollective.com/herimshin" target="_blank">Herim Shin</a></span><br />
                  <span class="serif">Andrea Juhie Kim</span>
              </p><br />
              <p class="about-link"><span class="bold">Colophon</span><br />
                  <span class="serif">English type set in <a href="https://fonts.google.com/specimen/Work+Sans" target="_blank">Work Sans</a> and <a href="https://fonts.google.com/specimen/Bitter" target="_blank">Bitter</a>. Korean type set in <a href="https://www.google.com/get/noto/help/cjk/" target="_blank">Noto Sans CJK</a> and <a href="http://hangeul.naver.com/" target="_blank">Nanum Myeongjo</a>. Made with <a href="https://vuejs.org/" target="_blank">Vue</a>.</span>
              </p>
          </div>
          <div class="column--one-third spacer--small spacer--left caption about-link">
              <p><span class="bold">Bibliography</span></p>
              <p>Boardly, John. “The Origins of Abc” I Love Typography. 07 Aug 2010. <a href="http://ilovetypography.com/" target="_blank">ilovetypeography.com</a></p>
              <p>Bringhurst, Robert. The Elements of Typographic Style. Point Roberts, WA: Hartley &amp; Marks, 2002.</p>
              <p>Graig, James and Susan E. Meyer Designing with Type: A Basic Course in Typography. New York: Watson-Guptill Publications, 1980.</p>
              <p>Glyph of the Day. <a href="http://www.glyphs.webfoot.com" target="_blank">glyphs.webfoot.com</a></p>
              <p>Kim, Young-hyun, and Sang-yeon Park. Tree With Deep Roots. SBS. Seoul, 2011. Television.</p>
              <p>Korean Typographics Association. KaNaDaRa. 4th ed. Vol 1. Seoul: Korean Typographics Association, 2012.</p>
          </div>
          <div class="clear"></div>
                <!-- <p class="spacer--medium center"><a href="/static/types-of-type-press-kit.zip" class="button caps">Download Press-Kit</a></p> -->
      </div>
    <div class="spacer--medium clear"></div>
  </div>
</template>

<script>
export default {
  name: 'about',
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// About.vue?6676ff2d